import React from 'react';
export function useEmitted(defaultValue, emitter) {
    const [value, setValue] = React.useState(defaultValue);
    React.useEffect(() => {
        const listener = (value) => setValue(value);
        emitter.on('change', listener);
        return () => {
            emitter.off('change', listener);
        };
    }, [emitter]);
    return value;
}
